import { useMemo } from "react";
import { omit } from "@common/helpers/objects";
import { HistoryFilter } from "@common/types/auditLog";
import { useGetHistoryDailyCountsQuery } from "@api/auditLog.api";
import { CalendarHeatmap } from "@design-system/CalendarHeatmap/CalendarHeatmap";
import { CalendarHeatmapDatum } from "@design-system/CalendarHeatmap/CalendarHeatmap.lib";
import styles from "./HistoryPage.module.scss";

interface HistoryHeatmapProps {
    filters: HistoryFilter;
    onDateSelect?: (date: string) => void;
}

export const HistoryHeatmap = ({
    filters,
    onDateSelect,
}: HistoryHeatmapProps) => {
    const heatmapFilters = useMemo(
        () => omit(filters, "minCreatedAt", "maxCreatedAt"),
        [filters],
    );
    const { data, isLoading } = useGetHistoryDailyCountsQuery({
        filters: heatmapFilters,
    });

    const heatmapData = useMemo<CalendarHeatmapDatum[]>(
        () =>
            (data?.data ?? []).map((item) => ({
                date: item.date,
                value: item.count,
            })),
        [data?.data],
    );

    if (isLoading || !data?.range) {
        return <div className={styles.heatmap} aria-hidden />;
    }

    return (
        <div className={styles.heatmap}>
            <CalendarHeatmap
                data={heatmapData}
                startDate={data.range.start}
                endDate={data.range.end}
                ariaLabel="Activity heatmap"
                onCellClick={(cell) => onDateSelect?.(cell.date)}
            />
        </div>
    );
};
